// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {ComponentProps, forwardRef} from 'react';
import {Button as Basic_button} from '../../../hola/pub/lib/button';
import {Button as Button_shared} from '../../../toolip/pub/ui/shared/button';

export type t_oculus_button_color = 'primary' | 'secondary' | 'tertiary'
    | 'destructive' | 'social' | 'transparent';
export type t_oculus_button_size = 'l' | 'm' | 's' | 'xs' | 'xxs';

export type t_oculus_button_props = ComponentProps<typeof Basic_button> & {
    color?: t_oculus_button_color;
    size?: t_oculus_button_size;
    icon_only?: boolean;
};

export const Button = forwardRef<HTMLButtonElement, t_oculus_button_props>(
    (props, ref)=>
        <Button_shared {...props} ref={ref}/>
);
